import axios from 'axios';

const API_BASE_URL = 'https://' + process.env.API_HOST;

// 获取缓存中的 Token
export const getCachedToken = () => {
  const data = JSON.parse(localStorage.getItem('connectNow'));
  if (data) {
    const { access_token, expires_in } = data;
    const currentTime = new Date().getTime();
    if (currentTime < expires_in) {
      return `Bearer ${access_token}`;
    }
  }
  return null;
};

// 更新 Token
export const updateToken = async () => {
  const params = {
    client_id: process.env.CLIENT_ID,
    client_secret: process.env.SECURITY_KEY,
  };
  const response = await axios.post(API_BASE_URL + '/api/openapi/oauth/token', params);
  if (response.data.code === 200) {
    const tokenData = response.data.data;
    localStorage.setItem('connectNow', JSON.stringify(tokenData));
    return `Bearer ${tokenData.access_token}`;
  } else {
    throw new Error('Failed to fetch token');
  }
};
